import { AXIOS_INSTANCE } from "../config";

export const axiosMutiRequests =
  ({ requestsList, ACTION_LOADING, ACTION_SUCCESS, ACTION_ERROR }) =>
  (dispatch) => {
    dispatch({
      type: ACTION_LOADING,
    });
    return Promise.all(requestsList)
      .then((res) => {
        dispatch({
          type: ACTION_SUCCESS,
          payload: res,
        });
      })
      .catch((err) => {
        dispatch({
          type: ACTION_ERROR,
          message: err,
        });
      });
  };

export const configAxiosMutiRequest = ({
  url,
  method,
  data = {},
  params = {},
}) =>
  AXIOS_INSTANCE.request({
    url,
    method,
    data,
    params,
  });
